import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from '@mui/material';
import { LocationVm } from 'api/warehouse/location.vm';
import { GetLocationsVm } from 'api/warehouse/get-locations.vm';
import { getLocations } from 'api/warehouse/get-locations';

interface LocationSelectionDialogProps {
  open: boolean;
  warehouseId: string;
  onClose: () => void;
  onLocationSelect: (location: LocationVm) => void;
}

export const LocationSelectionDialog = ({ open, warehouseId, onClose, onLocationSelect }: LocationSelectionDialogProps) => {
  const [locations, setLocations] = useState<LocationVm[]>([]);
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState<string>('');
  const [hasMore, setHasMore] = useState(true);

  const fetchLocations = (reset = false) => {
    setLoading(true);
    getLocations(warehouseId, reset ? '' : offset, {
      success: (response: GetLocationsVm) => {
        setLocations((prev) => (reset ? response.objects : [...prev, ...response.objects]));
        setOffset(response.nextOffset || '');
        setHasMore(Boolean(response.nextOffset));
        setLoading(false);
      },
      error: (err) => {
        console.error('Falha ao carregar localizações:', err);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    if (open && warehouseId) {
      fetchLocations(true);
    }
  }, [open, warehouseId]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Selecionar Localização</DialogTitle>
      <DialogContent>
        {loading && locations.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : locations.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            Nenhuma localização encontrada.
          </Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {locations.map((location) => (
                  <TableRow key={location.id} hover onClick={() => onLocationSelect(location)} sx={{ cursor: 'pointer' }}>
                    <TableCell>{location.id}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {hasMore && !loading && (
          <Box sx={{ mt: 2 }}>
            <Button fullWidth onClick={() => fetchLocations()} disabled={loading}>
              Carregar mais
            </Button>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};
